import React, { useState, useEffect, useRef, useCallback } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import PageHero from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import EnquiryCard from "components/home-cards/EnquiryCard";
import { X } from "lucide-react";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const ReadMore = styled.span`
  ${tw`cursor-pointer text-blue-600 hover:underline`}
`;
const HeadingRow = tw.div`flex justify-between`;
const ButtonAction = tw.button`rounded-full px-3 py-1 mt-2 text-xs sm:text-sm sm:mt-4 sm:px-2 sm:py-2 font-bold shadow transition duration-300 bg-[#0049AC] text-white focus:outline-none focus:shadow-outline`;
const Title = tw.div`font-black text-sm lg:text-lg text-gray-900 group-hover:text-[#0049AC] transition duration-300`;
const TitleAddress = tw.div`font-black text-xs lg:text-sm text-gray-700 group-hover:text-[#0049AC] transition duration-300`;


const Heading = tw(SectionHeading)`hover:text-[#0049AC]  lg:text-3xl mt-4 mb-0 text-lg`;
const MapContainer = tw.div`w-full h-[500px] mt-5 relative`;
// const FloatingCard = styled.div`
//   ${tw`absolute bg-white shadow-lg p-4 rounded-lg w-40 lg:w-80 max-w-full`}
//   bottom: 20px;
//   left: 50%;
//   transform: translateX(-50%);
//   z-index: 10;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
// `;
const FloatingCard = styled.div`
  ${tw`
    absolute
    bg-white
    shadow-lg
    p-4
    rounded-lg
    w-72
    sm:w-80
    md:w-96
    lg:w-[28rem]
    max-w-full
    flex
    flex-col
    items-center
    text-center
    z-10
  `}
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
`;


const CloseIcon = tw.button`absolute top-0 mt-2 mr-2 right-0 text-gray-600 hover:text-gray-900`;
const Image = tw.img`w-full h-32 lg:h-40 object-cover mt-2 bg-cover bg-center rounded-t-lg`;
const CardGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10`;
const Card = tw.div`mt-10 w-full sm:pr-8 bg-white rounded-lg shadow-lg p-4 flex flex-col items-center justify-between h-full`;

export default () => {
  const [destinations, setDestinations] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 });

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const observer = useRef();

  const fallbackData = [
    {
      id: 1,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 27.1751,
      longitude: 78.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 2,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 48.8584,
      longitude: 12.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 3,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 40.4319,
      longitude: 63.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
      id: 4,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 27.1751,
      longitude: 76.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 5,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 45.8584,
      longitude: 12.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 6,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 60.4319,
      longitude: 16.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
      id: 7,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 14.1751,
      longitude: 63.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 8,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 69.8584,
      longitude: 56.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 9,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 23.4319,
      longitude: 85.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
      id: 10,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 63.1751,
      longitude: 74.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 11,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 65.8584,
      longitude: 29.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 12,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 65.4319,
      longitude: 14.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    }
    , {
      id: 13,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 66.1751,
      longitude: 79.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 14,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 25.8584,
      longitude: 30.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 15,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 36.4319,
      longitude: 42.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    }
    , {
      id: 16,
      name: "Taj Mahal",
      description: "A UNESCO World Heritage Site and one of the Seven Wonders of the World.",
      location: "Agra, India",
      latitude: 56.1751,
      longitude: 59.0421,
      image: "https://images.pexels.com/photos/1583339/pexels-photo-1583339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 17,
      name: "Eiffel Tower",
      description: "An iconic landmark in Paris, France.",
      location: "Paris, France",
      latitude: 58.8584,
      longitude: 22.2945,
      image: "https://images.pexels.com/photos/30520269/pexels-photo-30520269/free-photo-of-eiffel-tower-from-below-in-paris-scenery.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 18,
      name: "Great Wall of China",
      description: "A historic fortification stretching across China.",
      location: "China",
      latitude: 53.4319,
      longitude: 59.5704,
      image: "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=600"
    }
  ];

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  useEffect(() => {
    fetchDestinations();
  }, []);

  const fetchDestinations = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/web/destinations/destination-list`, {
        headers: {
          'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
        }
      }/*?page=${page}&limit=10*/);
      const result = await response.json();
      if (result.header.resCode == 200 && result.data.length > 0) {
        setDestinations(result.data);
      }
    } catch (error) {
      console.error("Error fetching destinations:", error);
    }
    setLoading(false);
  };

  // const lastDestinationRef = useCallback(
  //   (node) => {
  //     if (observer.current) observer.current.disconnect();
  //     observer.current = new IntersectionObserver(
  //       (entries) => {
  //         if (entries[0].isIntersecting && loading) {
  //           fetchDestinations(); // Load more destinations only when the last one is visible
  //         }
  //       },
  //       { threshold: 1.0 }
  //     );
  //     if (node) observer.current.observe(node);
  //   },
  //   [loading, fetchDestinations]
  // );

  return (
    <AnimationRevealPage>
      <PageHero pageName="Destinations" titleName="" />
      <Container>
        <HeadingRow>
          <Heading>Explore More, Discover More – Your Next Adventure Awaits!</Heading>
        </HeadingRow>

        <MapContainer>
          <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_PUBLIC_KEY}>
            <GoogleMap mapContainerStyle={{ width: "100%", height: "100%" }} center={mapCenter} zoom={5}>
              {destinations.map((dest) => (
                <Marker key={dest.id} position={{ lat: dest.latitude, lng: dest.longitude }} onClick={() => setSelectedDestination(dest)} />
              ))}
            </GoogleMap>
          </LoadScript>

          {selectedDestination && (
            <FloatingCard>
              <Title>{selectedDestination.name}</Title>
              <CloseIcon onClick={() => setSelectedDestination(null)}>
                <X size={20} />
              </CloseIcon>

              <p tw="text-xs lg:text-sm text-gray-700">
                {selectedDestination.description.substring(0, 200)}
                <ReadMore
                  onClick={() =>
                    window.location.href = `/pg/destinations/explore/${selectedDestination.id}`
                  }
                >
                  ...more
                </ReadMore>
              </p>
              <TitleAddress>{selectedDestination.location}</TitleAddress>
              <Image
                src={selectedDestination.image}
                alt={selectedDestination.name}
              />
              <ButtonAction
                onClick={() =>
                  window.location.href = `/pg/destinations/explore/${selectedDestination.id}`
                }
              >
                View Destination
              </ButtonAction>
            </FloatingCard>

          )}
        </MapContainer>

        <CardGrid>
          {destinations.map((dest, index) => (
            <Card key={dest.id} /*ref={index === destinations.length - 1 ? lastDestinationRef : null}*/>
              <Title tw="font-bold text-lg">{dest.name}</Title>
              <p>
                {dest.description.substring(0, 250)}
                <ReadMore
                  onClick={() =>
                    window.location.href = `/pg/destinations/explore/${dest.id}`
                  }
                >
                  ...more
                </ReadMore>
              </p>
              <Image src={dest.image} alt={dest.name} />
              <ButtonAction onClick={() => window.location.href = `/pg/destinations/explore/${dest.id}`} >
                View Destination
              </ButtonAction>
            </Card>
          ))}
        </CardGrid>
        {loading && <p tw="text-center mt-4">Loading more destinations...</p>}
        <br />
        <EnquiryCard />
      </Container>
      <FooterCard />
    </AnimationRevealPage>
  );
};
